export default "__VITE_ASSET__BUHqsPWE__"